var _path, _circle, _path2, _path3, _rect, _rect2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadImageColorFinder = function SvgUploadImageColorFinder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    d: "M25.058 20.863H1.369a.87.87 0 0 1-.869-.869V2.404c0-.48.39-.869.869-.869h23.689c.48 0 .869.39.869.87v17.589c0 .48-.39.869-.87.869Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.273,
    cy: 5.738,
    r: 2.238,
    stroke: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m.389 15.063 3.443-3.291a1.37 1.37 0 0 1 1.894.002l4.477 4.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "m25.725 14.933-.955-.956-5.181-5.18a1.37 1.37 0 0 0-1.936 0L8.459 17.99"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.864,
    height: 10.864,
    x: 16.635,
    y: 15.535,
    fill: "#fff",
    rx: 5.432
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.864,
    height: 10.864,
    x: 16.635,
    y: 15.535,
    stroke: "#000",
    rx: 5.432
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "m22.062 23.58.003-5.29m0 0a.11.11 0 0 0-.079.029l-2.503 2.518m2.582-2.548q.036 0 .063.03l2.503 2.518"
  })));
};
export default SvgUploadImageColorFinder;